import { useMutation } from "@tanstack/react-query";
import httpClientCron from "../../../api/module/httpClientCron";

const createComment = async ({ certificateId, data }) => {
  const response = await httpClientCron.post(
    `private/certificate/${certificateId}/group-comment`,
    data
  );

  return response.data;
};

export const useCreateGroupCertificateComment = ({
  onSuccess,
  onMutate,
  onError,
  onSettled,
}) => {
  return useMutation({
    mutationFn: createComment,
    onSuccess,
    onMutate,
    onError,
    onSettled,
  });
};
